<template>
  <div>
      <LoginAccountTab :activeName="activeName" />
      <div class="content-container">
      <!-- <div class="content-form"> -->
        <ContentBox>
          <div style="height:34px; margin-bottom:24px">
            <div v-if="partnerInfo" :class="'content-container'+partnerInfo.icon">
              <i :class="partnerInfo.icon"></i>
              <span>{{partnerInfo.text}}</span>
            </div>
          </div>
        <el-form
          class="demo-ruleForm"
          label-position="left"
          label-width="117px"
          :rules="rules"
          ref="qualificationForm"
          :model="qualificationForm"
           hide-required-asterisk>
          <el-form-item label="类型" prop="registerType" :rules="[
      { required: true, message: '请选类型', trigger: 'blur' }
    ]">
            <el-radio-group v-model="qualificationForm.registerType" :disabled="qualificationForm.partnerStatus === 0 || qualificationForm.partnerStatus === 1">
              <el-radio-button size="medium" :label="0" class="form-radio-button">企业</el-radio-button>
              <el-radio-button size="medium" :label="1" class="form-radio-button" >个人</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <template v-if="qualificationForm.registerType === 0">
            <el-form-item  prop="partnerName" :rules="[
      { required: true, message: '请输入公司名称', trigger: 'blur' }
    ]">
    <span slot="label">
      <span>公司名称</span>
      <span class="sub-title">(必填)</span>
    </span>
              <el-input v-noEmoji class="demo-ruleForm-input" v-noSpace v-model="qualificationForm.partnerName" placeholder="请填写公司名称"/>
            </el-form-item>
            <el-form-item label="证件类型" prop="companyNature">
              <div class="demo-ruleForm-box">
              <el-select v-model="qualificationForm.companyNature" placeholder="请选择" class="demo-ruleForm-half-select">
                  <el-option label="企业" :value="0"></el-option>
                  <el-option label="个体账户" :value="1"></el-option>
                  <el-option label="政府组织机构/事业单位" :value="2"></el-option>
                  <el-option label="港澳台" :value="3"></el-option>
                  <el-option label="其他机构" :value="4"></el-option>
                  <el-option label="海外" :value="5"></el-option>
              </el-select>
              <el-select v-model="qualificationForm.licenseType" placeholder="请选择" class="demo-ruleForm-half-select">
                  <el-option label="组织机构代码代号" :value="0"></el-option>
                  <el-option label="企业营业执照统一社会信用代码" :value="1"></el-option>
                  <el-option label="企业营业执照注册号" :value="2"></el-option>
              </el-select>
              <div class="remark-tip">优先选择“营业执照统一社会信用代码”；若无则按照实际情况填写</div>
              </div>

            </el-form-item>
            <el-form-item label="资质照片" class="qualify-item" prop="license" :rules="[
      { required: true }
    ]">
               <div class="demo-ruleForm-box">
              <el-upload
                class="avatar-uploader"
                :action="uploadImgUrl"
                :show-file-list="false"
                :on-success="handleLicenseSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="qualificationForm.license !== ''" :src="qualificationForm.license" class="avatar">
              <div class="text-wrapper" v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="text-tip">请上传资质编号清晰可见的相关资质照片。仅持jpg、png、jpeg格式图片，小于5M。</div>
                </div>
              </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="资质编号" prop="licenseSn">
              <div class="demo-ruleForm-box">
              <el-input v-noEmoji class="demo-ruleForm-input" v-noSpace v-model="qualificationForm.licenseSn" placeholder="请先选择证件类型，再填写资质编号"/>
              <div class="remark-tip">请确保所填资质编号与资质照片上的一致</div>
              </div>
            </el-form-item>
            <el-form-item label="证件有效期" prop="licenseUsefulLifeTime">
              <div class="demo-ruleForm-box">
               <el-select v-model="qualificationForm.licenseUsefulLifeType" placeholder="请选择" :class=" qualificationForm.licenseUsefulLifeType === 0 ? 'demo-ruleForm-half-select' : 'demo-ruleForm-select'">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <template v-if="qualificationForm.licenseUsefulLifeType ===0">
              <el-date-picker
                v-model="qualificationForm.licenseUsefulLifeTime"
                type="date"
                placeholder="选择日期"
                class="demo-ruleForm-half-picker"
                :picker-options="pickerOptions"
                >
              </el-date-picker>
              </template>
              <div class="remark-tip">请与资质照片上的有效期保持一致，若为长期有效证件请选择“无截止日期”</div>
              </div>
            </el-form-item>
            <el-form-item label="法人/经营者" prop="legalPerson">
              <el-input v-noEmoji class="demo-ruleForm-input" v-noSpace v-model="qualificationForm.legalPerson" placeholder="请与照片中的法人/经营者保持一致"/>
            </el-form-item>
            <el-form-item label="法人身份证">
              <div class="demo-ruleForm-box">
              <el-upload
                class="avatar-uploader-card"
                :action="uploadImgUrl"
                :show-file-list="false"
                :on-success="handleIdentitySuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="qualificationForm.identityCardFront !== ''" :src="qualificationForm.identityCardFront" class="avatar">
                <div v-else class="text-wrapper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="text-title">法人身份证正面</div>
                  <div class="text-tip">jpeg/png，小于5MB</div>
                </div>
              </el-upload>
              <el-upload
                class="avatar-uploader-card"
                :action="uploadImgUrl"
                :show-file-list="false"
                :on-success="handleCardContrarySuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="qualificationForm.identityCardContrary !== ''" :src="qualificationForm.identityCardContrary" class="avatar">
                <div v-else class="text-wrapper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="text-title">法人身份证反面</div>
                  <div class="text-tip">jpeg/png，小于5MB</div>
                </div>
              </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="法人身份证号" prop="identityCardNo"  :rules="[
      { required: true, message: '请输入法人身份证号', trigger: 'blur' }
    ]">
              <el-input v-noEmoji class="demo-ruleForm-input" v-noSpace v-model="qualificationForm.identityCardNo" placeholder="请填写法人身份证号"></el-input>
            </el-form-item>
            <el-form ref="regAddress" :model="regAddress" :rules="regRules"   label-position="left"  hide-required-asterisk
          label-width="117px">
            <el-form-item label="注册地" prop="provincesId">
              <div class="demo-ruleForm-box">
              <el-select v-model="regAddress.provincesId" placeholder="请选择" class="demo-ruleForm-half-select" @change="handleRegionsDataChange">
                  <el-option v-for="item in regionsData" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-model="regAddress.regionId" placeholder="请选择" class="demo-ruleForm-half-select">
                  <el-option v-for="item in regionsDataChild" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div class="remark-tip">请与资质照片上的注册地保持一致。若下拉列表中无该注册地城市，请联系销售或运营</div>
              </div>
            </el-form-item>
            </el-form>
          </template>
          <template v-else>
            <el-form-item  prop="partnerName" :rules="[
      { required: true, message: '请输入个人姓名', trigger: 'blur' }
    ]">
     <span slot="label">
      <span>个人姓名</span>
      <span class="sub-title">(必填)</span>
    </span>
              <el-input v-noEmoji class="demo-ruleForm-input" v-noSpace v-model="qualificationForm.partnerName" placeholder="请填写个人姓名"/>
            </el-form-item>
            <el-form-item prop="licenseType">
                  <span slot="label">
                    <span>证件类型</span>
                    <span class="sub-title">(必填)</span>
                  </span>
              <el-select v-model="qualificationForm.licenseType" placeholder="请选择" class="demo-ruleForm-select">
                  <el-option label="身份证号" :value="0"></el-option>
                  <el-option label="护照号" :value="1"></el-option>
                  <el-option label="个人港澳/台湾居民往来大陆通行证证号" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件照片">
              <div class="demo-ruleForm-box">
              <el-upload
                class="avatar-uploader-front-img"
                :action="uploadImgUrl"
                :show-file-list="false"
                :on-success="handleIdentitySuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="qualificationForm.identityCardFront !== ''" :src="qualificationForm.identityCardFront" class="avatar">
                <div v-else class="text-wrapper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="text-title">身份证正面</div>
                  <div class="text-tip">jpeg/png，小于5MB</div>
                </div>
              </el-upload>
              <el-upload
               class="avatar-uploader-front-img"
                :action="uploadImgUrl"
                :show-file-list="false"
                :on-success="handleCardContrarySuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="qualificationForm.identityCardContrary !== ''" :src="qualificationForm.identityCardContrary" class="avatar">
                <div v-else class="text-wrapper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="text-title">身份证反面</div>
                  <div class="text-tip">jpeg/png，小于5MB</div>
                </div>
              </el-upload>
              <el-upload
               class="avatar-uploader-front-img"
                :action="uploadImgUrl"
                :show-file-list="true"
                :on-success="handleLicenseSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="qualificationForm.license !== ''" :src="qualificationForm.license" class="avatar">
                <div v-else class="text-wrapper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="text-title">手持身份证照</div>
                  <div class="text-tip">jpeg/png，小于5MB</div>
                </div>
              </el-upload>
              </div>
            </el-form-item>
            <el-form-item prop="identityCardNo"  :rules="[
      { required: true, message: '请输入证件编号', trigger: 'blur' }
    ]">
                 <span slot="label">
                    <span>证件编号</span>
                    <span class="sub-title">(必填)</span>
                  </span>
              <div class="demo-ruleForm-box">
              <el-input v-noEmoji class="demo-ruleForm-input" v-noSpace v-model="qualificationForm.identityCardNo" placeholder="请先选择证件类型，再填写资质编号"/>
              <div class="remark-tip">请确保所填身份证编号与身份证照片上的一致</div>
              </div>
            </el-form-item>
            <el-form-item label="证件有效期" prop="licenseUsefulLifeTime">
              <div class="demo-ruleForm-box">
                <el-select v-model="qualificationForm.licenseUsefulLifeType" placeholder="请选择" :class=" qualificationForm.licenseUsefulLifeType === 0 ? 'demo-ruleForm-half-select' : 'demo-ruleForm-select'">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <template v-if="qualificationForm.licenseUsefulLifeType ===0">
              <el-date-picker
                class="demo-ruleForm-half-picker"
                v-model="qualificationForm.licenseUsefulLifeTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                >
              </el-date-picker>
              </template>
              <div class="remark-tip">请与身份证照片上的有效期保持一致，若为长期有效证件请选择“无截止日期”</div>
              </div>
            </el-form-item>
          </template>
        </el-form>
        </ContentBox>

      <!-- </div> -->
        <!-- <ContentBox title="操作日志" class="content-box">
        <Table
          :props="logTable.props"
          :header="logTable.header"
          :data="logTable.data"
          v-loading="loading"
        />
      </ContentBox> -->
       <ContentBox>
         <el-button v-if="qualificationForm.partnerStatus === 4" :loading="saveLoading" @click="eqSave('qualificationForm',0)">保存草稿</el-button>
          <el-button v-if="!qualificationForm.partnerStatus"  type="primary" :disabled="isDisabledBtn" :loading="submitLoading" @click="eqSave('qualificationForm',1)">提交审核</el-button>
          <el-button v-if="qualificationForm.partnerStatus && qualificationForm.partnerStatus !== 4 " type="primary" :loading="againSubmitLoding"  @click="eqSave('qualificationForm',2)">重新送审</el-button>
      </ContentBox>
      </div>
  </div>
</template>

<script>
import LoginAccountTab from './components/LoginAccountTab'
export default {
  components: {
    LoginAccountTab
  },
  data() {
    var validateProvince = (rule, value, callback) => {
      if (value) {
        if (this.regAddress.regionId) {
          callback()
        } else {
          callback(new Error('请选择注册地'))
        }
        callback()
      } else {
        callback(new Error('请选择注册地'))
      }
    }
    return {
      activeName: 'entityQualification',
      qualificationFormLoaded: false,
      qualificationForm: {
        registerType: '',
        partnerName: '',
        companyNature: '',
        licenseType: '',
        license: '', // 资质图片或手持图片
        licenseSn: '', // 编号
        licenseUsefulLifeType: 0, // 0:短期有效，1:长期有效
        licenseUsefulLifeTime: undefined, // 有效期
        legalPerson: '', // 法人/经营者
        identityCardFront: '', // 证件照正面
        identityCardContrary: '', // 证件照反面
        identityCardNo: '' // 身份证号
      },
      qualificationFormValid: {
        registerType: 0,
        partnerName: '',
        companyNature: '',
        licenseType: '',
        license: '', // 资质图片或手持图片
        licenseSn: '', // 编号
        licenseUsefulLifeType: 0, // 0:短期有效，1:长期有效
        licenseUsefulLifeTime: '', // 有效期
        legalPerson: '', // 法人/经营者
        identityCardFront: '', // 证件照正面
        identityCardContrary: '', // 证件照反面
        identityCardNo: '' // 身份证号
      },
      qualificationFormMeValid: {
        registerType: 0,
        partnerName: '',
        licenseType: '',
        license: '', // 资质图片或手持图片
        licenseUsefulLifeType: 0, // 0:短期有效，1:长期有效
        licenseUsefulLifeTime: '', // 有效期
        identityCardFront: '', // 证件照正面
        identityCardContrary: '', // 证件照反面
        identityCardNo: '' // 身份证号
      },
      rules: {
        // companyNature: [
        //   { required: true, message: '请选择证件类型', trigger: 'change' }
        // ],
        licenseType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        qualificationCode: [{ required: true, message: '请填写证件编号', trigger: 'blur' }],
        // identityCardNo: [{ required: true, message: '请填写证件编号', trigger: 'blur' }],
        // licenseSn: [{ required: true, message: '请填写资质编号', trigger: 'blur' }],
        // legalPerson: [{ required: true, message: '请填写法人/经营者', trigger: 'blur' }],
        license: [{ required: true, message: '11', trigger: 'blur' }]
        // licenseUsefulLifeTime: [{ type: 'date', required: true, validator: validateTime, trigger: 'blur' }]
      },

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      options: [
        {
          value: 0,
          label: '有效期至'
        }, {
          value: 1,
          label: '长期有效'
        }
      ],
      againSubmitLoding: false,
      saveLoading: false,
      submitLoading: false,
      regAddress: {
        provincesId: '',
        regionId: ''
      },
      regRules: {
        provincesId: [{ required: true, validator: validateProvince, trigger: 'change' }]
      },
      uploadImgUrl: 'api/dsp/adDspPartner/uploadFile',
      regionsData: [],
      regionsDataChild: [],
      regionId: undefined,
      logTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h('TimeFormat', {
                props: {
                  value: row.createTime
                }
              })
            }
          },
          {
            label: '操作人',
            prop: 'operator',
            align: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: '操作类型',
            prop: 'type',
            align: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: '执行结果',
            prop: 'description',
            align: 'left',
            'show-overflow-tooltip': true
          }
        ],
        data: []
      }
    }
  },
  computed: {
    isDisabledBtn() {
      let isDisabled = true
      let flag = false
      let qForm = this.qualificationForm
      if (qForm.registerType === 0) {
        let qFormValid = this.qualificationFormValid
        for (let item in qFormValid) {
          if (qForm[item] === '' || qForm[item] === undefined || qForm[item] === null) {
            flag = true
            break
          }
        }
      } else if (qForm.registerType === 1) {
        let qFormMeValid = this.qualificationFormMeValid
        for (let params in qFormMeValid) {
          if (qForm[params] === '' || qForm[params] === undefined || qForm[params] === null) {
            flag = true
            break
          }
        }
      }
      if (flag) {
        isDisabled = true
      } else {
        isDisabled = false
      }
      return isDisabled
    },
    // 主体资质信息提示
    partnerInfo() {
      if (!this.qualificationFormLoaded) {
        return null
      }
      let info = {
        text: '您的的主体资质信息尚不完整，请尽快补全。补全信息并通过账户审核后方可正常投放广告',
        icon: 'el-icon-warning'
      }
      if (this.qualificationForm.partnerStatus === 2) {
        info.text = '您的资质信息正在审核中，预计3个工作日内完成。审核通过后可正常投放广告'
        info.icon = 'el-icon-info'
      } else if (this.qualificationForm.partnerStatus === 0 || this.qualificationForm.partnerStatus === 1) { // 启用和禁用状态也就是审核通过
        info.text = '恭喜！您的资质已审核通过，可投放广告。如有问题，请联系客户经理。'
        info.icon = 'el-icon-success'
      } else if (this.qualificationForm.partnerStatus === 3) {
        info.text = '您的资质未审核通过，请重新修改后提交'
        info.icon = 'el-icon-error'
      } else if (this.qualificationForm.partnerStatus === 4) {
        info.text = '您的的主体资质信息尚不完整，请尽快补全。补全信息并通过账户审核后方可正常投放广告'
        info.icon = 'el-icon-warning'
      }
      return info
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const suffix = file.name.split('.').slice(-1)[0]
      const extension = suffix === 'jpg'
      const extension2 = suffix === 'jpeg'
      const extension3 = suffix === 'png'
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!extension && !extension2 && !extension3) {
        this.$message('上传图片格式必须为jpg/jpeg/png格式')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return (extension || extension2 || extension3) && isLt2M
    },
    handleLicenseSuccess(res, file) {
      if (res.code === 0) {
        this.qualificationForm.license = res.data.mediaIcon
      }
    },
    handleIdentitySuccess(res, file) {
      if (res.code === 0) {
        this.qualificationForm.identityCardFront = res.data.mediaIcon
      }
    },
    handleCardContrarySuccess(res, file) {
      if (res.code === 0) {
        this.qualificationForm.identityCardContrary = res.data.mediaIcon
      }
    },
    eqSave(formName, val) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.qualificationForm.registerType === 0) {
            this.$refs.regAddress.validate((valid) => {
              if (valid) {
                this.handleSave(val)
              }
            })
          } else {
            this.handleSave(val)
          }
        }
      })
    },
    handleSave(val) {
      this.saveLoading = val === 0
      this.submitLoading = val === 1

      let params = this.qualificationForm
      params.saveStatus = val === 2 ? 1 : val
      params.registeredAddress = this.regAddress.provincesId + ',' + this.regAddress.regionId
      if (params.licenseUsefulLifeType === 1) {
        params.licenseUsefulLifeTime = undefined
      }
      params.identityCardNo = params.identityCardNo ? this.$encrypt(params.identityCardNo) : ''
      this.$confirm('在重新审核通过前，全部投放会暂停,是否重新送审', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      })
        .then(() => {
          this.againSubmitLoding = true
          this.$service.getAccAdDspPartnerSave(params, '操作成功').then(data => {
            this.getAccAdDspPartnerCurrDetail()
            this.saveLoading = false
            this.submitLoading = false
            this.againSubmitLoding = false
          }).catch(() => {
            this.saveLoading = false
            this.submitLoading = false
            this.againSubmitLoding = false
          })
        })
        .catch(() => {})
    },
    getRegionList() {
      this.$service.getRegionList({}).then(data => {
        const areaData = data.slice().filter(item => {
          return item.name !== '未匹配'
        })
        areaData.forEach(item => {
          if (item.parent === 0) {
            this.regionsData.push({
              value: item.regionId,
              label: item.name,
              children: []
            })
          }
        })
        for (let i = 0; i < this.regionsData.length; i++) {
          for (let j = 0; j < areaData.length; j++) {
            if (areaData[j].parent === this.regionsData[i].value) {
              this.regionsData[i].children.push({
                value: areaData[j].regionId,
                label: areaData[j].name
              })
            }
          }
        }
        this.getAccAdDspPartnerCurrDetail()
      }).catch(() => {
      })
    },
    handleRegionsDataChange() {
      const regData = this.regionsData
      for (let i = 0; i < regData.length; i++) {
        if (regData[i].value === this.regAddress.provincesId) {
          this.regionsDataChild = regData[i].children
          break
        }
      }
    },
    getAccAdDspPartnerCurrDetail() {
      this.$service.getAccAdDspPartnerCurrDetail({}).then(data => {
        this.qualificationForm = this.cloneDeep(data)
        this.qualificationForm.identityCardNo = this.$decrypt(data.identityCardNo)
        this.qualificationFormLoaded = true
        this.logTable.data = data.partnerLogList
        const addr = data.registeredAddress.split(',')
        if (addr[0]) this.regAddress.provincesId = parseInt(addr[0])
        if (addr[1]) this.regAddress.regionId = parseInt(addr[1])
        this.handleRegionsDataChange()
      }).catch(() => {
      })
    }
  },
  created() {
    this.getRegionList()
  }
}
</script>

<style lang="stylus" scoped>
.content-form
  padding 16px 32px
  background #fff
  border-radius 2px
.content-container
  margin 16px
>>>.content-box__main {
  margin-left: 32px;
}
>>>.el-radio-button__inner {
  width: 232px;
}
.demo-ruleForm-input,.demo-ruleForm-select, .avatar-uploader>>>.el-upload,.demo-ruleForm-picker {
  width 464px
}
// .avatar-uploader>>>.el-upload
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
.demo-ruleForm-half-select,.demo-ruleForm-half-picker{
  width 231px
  margin-right 2px
}
.demo-ruleForm-box {
  display flex
  align-items center
}
.remark-tip {
  min-width:317px;
  height:22px;
  font-size:12px;
  font-weight:400;
  color:rgba(0,0,0,0.45);
  line-height:22px;
  padding-left 8px
}
.demo-ruleForm-box .avatar-uploader>>>.el-upload
  width 462px
  height 130px
.avatar-uploader >>>.el-upload,.avatar-uploader-card >>>.el-upload,.avatar-uploader-front-img >>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader >>>.el-upload:hover,.avatar-uploader-card >>>.el-upload:hover,.avatar-uploader-front-img >>>.el-upload:hover {
    border-color: #ff8b00;
  }
  .avatar-uploader-icon {
    font-size: 24px;
    color: #8c939d;
    text-align: center;
  }
.avatar-uploader img,
.avatar-uploader-card img,
.avatar-uploader-front-img img
  max-width 100%
  max-height 100%
.demo-ruleForm-box .avatar-uploader-card>>>.el-upload:nth-child(1),.demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(1),.demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(2) {
  margin-right 2px
}
.demo-ruleForm-box .avatar-uploader-card>>>.el-upload {
  width 229px
  height 130px
}
.avatar-uploader-front-img >>>.el-upload {
  width 151px
  height 130px
}
.demo-ruleForm-box .avatar-uploader-front-img >>>.el-upload:nth-child(3) ,.demo-ruleForm-box .avatar-uploader-front-img:nth-child(3){
  width 152px
  margin-right 0
}
.avatar-uploader-card,.avatar-uploader
  // background url('../../assets/id-card-front.png') no-repeat
  background-size 100% 100%
  display inline-block
  align-items center
  justify-content center
  flex-direction column
  position relative
  vertical-align top
  height 130px
.avatar-uploader-opposite-img
  // background url('../../assets/id-card-opposite.png') no-repeat
  background-size 100% 100%
.avatar-uploader-none-img
  // background url('../../assets/id-card-none.png') no-repeat
  background-size 100% 100%
.avatar-uploader-card .text-wrapper
  text-align center
.avatar-uploader .avatar-uploader-icon
  margin-top 35px
>>>.avatar-uploader-icon
  font-size 24px
  margin-top 35px
.text-tip
  padding: 0 32px 0px 34px;
  font-size: 12px;
  color: rgba(0,0,0,0.45);
  height: 16px;
  line-height: 16px;
.text-title
  color:rgba(0,0,0,0.85);
  font-size:12px;
  height 22px
  line-height 22px
.avatar-uploader-front-img .text-tip
  padding 0
.content-containerel-icon-info,.content-containerel-icon-success,.content-containerel-icon-error,.content-containerel-icon-warning
  width:610px;
  height:32px;
  border-radius:4px;
  display: flex;
  flex-direction: row;
  align-items: center;
.content-containerel-icon-info
  background:rgba(236,246,253,1);
  border:1px solid rgba(173,216,247,1);
.content-containerel-icon-success
  background:rgba(235,248,242,1);
  border:1px solid rgba(167,225,196,1);
.content-containerel-icon-error
  background:rgba(254,243,235,1);
  border:1px solid rgba(252,204,167,1);
.content-containerel-icon-warning
  background:rgba(255,250,235,1);
  border:1px solid rgba(255,233,167,1);
.content-containerel-icon-info span,.content-containerel-icon-success span,.content-containerel-icon-error span,.content-containerel-icon-warning span
  // width:479px;
  height:18px;
  font-size:12px;
  font-weight:400;
  color:rgba(0,0,0,0.65);
  line-height:18px;
.content-containerel-icon-info i,.content-containerel-icon-success i,.content-containerel-icon-error i,.content-containerel-icon-warning i
  font-size 12px
  padding-right 8px
  padding-left 16px
.content-containerel-icon-info i
  color:rgba(16,142,233,1);
.content-containerel-icon-success i
  color:rgba(0,168,84,1);
.content-containerel-icon-warning i
  color:rgba(255,191,0,1);
.content-containerel-icon-error i
  color:rgba(245,106,0,1);
.sub-title
   color rgba(0,0,0,0.65)
   padding 0 5px
</style>
